import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { UserAdminService } from './../user-admin.service';
import { EventTypes } from './../../../shared/EventTypes';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { AutenticationService } from '../../../autentication/autentication.service';
import { EditUserData } from '../models/edit-user-data';
import { UserAdminEventType } from '../user-admin.event.type';
import { TweenMax, Quint } from 'gsap';
import { Auth } from '../../../autentication/Auth';
import { SharedService } from '../../../shared/shared.service';
import { Subscription } from 'rxjs/Subscription';
import { EditUserDataSend } from '../models/edit-user-data-send';
import { ThemeService } from '../../../shared/theme-service/theme.service';

@Component({
	selector: 'app-new-user-data',
	templateUrl: './new-user-data.component.html',
	styleUrls: ['./new-user-data.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class NewUserDataComponent implements OnInit, OnDestroy {

	@Input() submited = false;

	private view = '[data-component="new-user-data"]';
	private sendConfirmedUser = false;

	titleIndex = 0;
	titleForm = [
		'Digite o CPF do novo usuário:',
		'Altere os dados do usuário abaixo:',
		'Por favor, preencha os dados cadastrais abaixo:',
		'Foi encontrado um registro com este CPF em nosso banco de dados: '
	];
	accountFound = false;
	updateMode = false;
	insertMode = false;
	showCompleteForm = false;
	formUser: FormGroup;
	formSignature: FormGroup;
	formCpf: FormGroup;
	editUserData: EditUserData = new EditUserData();
	states: Array<any> = [];
	sending = false;
	active = true;
	userNotEditable = false;
	inputDisable = false;
	inputDisableCpf = false;
	newUser = false;
	editUserDataSend: EditUserDataSend = new EditUserDataSend();
	isAttendant = false;

	constructor(
		private autenticationService: AutenticationService,
		private userAdminService: UserAdminService,
		private formBuilder: FormBuilder,
		private themeService: ThemeService,
		public sharedService: SharedService) {

		this.formCpf = formBuilder.group({
			cpf: ['', [Validators.required, Validators.minLength(11)]]
		});

		this.formUser = formBuilder.group({
			name: ['', [Validators.required]],
			rg: ['', [Validators.required]],
			cellphone: ['', [Validators.required]],
			emails: this.formBuilder.group({
				email: ['', [Validators.email]],
				confirmEmail: ['', [Validators.email]],
			}, {validator: this.emailConfirming}),
			birthDate: ['', [Validators.required]],
			motherName: ['', [Validators.required]],
			nationality: ['brazilian', [Validators.required]],
			gender: ['', [Validators.required]],
			state: [''],
			city: ['', [Validators.required]]
		});
	}

	emailConfirming(c: AbstractControl): { invalid: boolean } {
		if (c.get('email').value !== c.get('confirmEmail').value) {
				return {invalid: true};
		}
	}

	ngOnInit() {
		this.isAttendant = this.themeService.isAttendant();

		AppEventDispatcher.listen(UserAdminEventType.USER_ADMIN_EDIT, data => {

			if (data.edit) {
				AppEventDispatcher.dispatch(UserAdminEventType.USER_CONFIRM, { show: false});
				this.getUserByCpf(true, data.cpf, true);
			}

		});

		AppEventDispatcher.listen(UserAdminEventType.USER_FORM, () => {
			this.active = true;
			this.show();
			this.formCpf.controls.cpf.enable();
		});

		AppEventDispatcher.listen(UserAdminEventType.USER_ADMIN_DELETE, (data) => {
			this.hide(data.msg, 'success', true);
		});

		this.states = this.userAdminService.getStates();

		this.show();
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(UserAdminEventType.USER_ADMIN_EDIT);
		AppEventDispatcher.removeListener(UserAdminEventType.USER_ADMIN_DELETE);
		AppEventDispatcher.removeListener(UserAdminEventType.USER_FORM);
	}

	onSetSignatureForm(form: FormGroup) {
		this.formSignature = form;

		if (this.sendConfirmedUser) {
			this.sendForm();
		}
	}

	getUserByCpf(itsUpdating, cpf, showErrorMessage) {

		this.preload(true);
		this.accountFound = false;

		this.formCpf.controls.cpf.enable();
		this.formUser.controls.name.enable();

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		this.userAdminService.editUserSend(cpf).subscribe(data => {
			this.editUserDataSend = data;
		}, error => {

			if (time > 3) {
				this.preload(false);
			}	else {
				TweenMax.delayedCall(3 - time, () => {
					this.preload(false, 3 - time);
				});
			}
			clearInterval(timeLoader);

			if (!itsUpdating) {
				this.showCompleteForm = true;
				this.updateHeight();
				this.insertMode = true;
				this.updateMode = false;
				this.titleIndex = 2;
				this.sending = false;
			}

			if (showErrorMessage) {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			}
		});

		this.userAdminService.editUser(cpf).subscribe(data => {

			this.editUserData = data;
			this.formCpf.controls.cpf.setValue(this.editUserData.userCpf);
			this.formUser.controls.name.setValue(this.editUserData.userName);
			this.formUser.controls.gender.setValue(this.editUserData.userGender);
			this.formUser.controls.rg.setValue(this.editUserData.userRG.trim());
			this.formUser.controls.cellphone.setValue(this.editUserData.userCellphone);
			this.formUser.get(['emails', 'email']).setValue(this.editUserData.userEmail);
			this.formUser.get(['emails', 'confirmEmail']).setValue(this.editUserData.userEmail);
			this.formUser.controls.birthDate.setValue(this.editUserData.userBirthDate);
			this.formUser.controls.motherName.setValue(this.editUserData.userMotherName);
			this.formUser.controls.nationality.setValue(this.editUserData.userBrazilian);
			this.formUser.controls.state.setValue(this.editUserData.userUF);
			this.formUser.controls.city.setValue(this.editUserData.userNaturalness);

			if (time > 3) {
				this.preload(false);
			}	else {
				TweenMax.delayedCall(3 - time, () => {
					this.preload(false, 3 - time);
				});
			}
			clearInterval(timeLoader);

			if (itsUpdating) {
				this.updateMode = true;
				this.insertMode = false;
				this.titleIndex = 1;
			} else {
				this.insertMode = true;
				this.updateMode = false;
				this.titleIndex = 3;
				this.accountFound = true;

				if (!this.editUserData.userEditable ) {
					this.formUser.controls.name.clearValidators();
					this.formUser.controls.name.updateValueAndValidity();
					this.formUser.controls.gender.clearValidators();
					this.formUser.controls.gender.updateValueAndValidity();
					this.formUser.controls.gender.disable();
					this.formUser.controls.rg.clearValidators();
					this.formUser.controls.rg.updateValueAndValidity();
					this.formUser.controls.cellphone.clearValidators();
					this.formUser.controls.cellphone.updateValueAndValidity();
					this.formUser.get(['emails', 'email']).clearValidators();
					this.formUser.get(['emails', 'email']).updateValueAndValidity();
					this.formUser.get(['emails', 'confirmEmail']).clearValidators();
					this.formUser.get(['emails', 'confirmEmail']).updateValueAndValidity();
					this.formUser.controls.birthDate.clearValidators();
					this.formUser.controls.birthDate.updateValueAndValidity();
					this.formUser.controls.motherName.clearValidators();
					this.formUser.controls.motherName.updateValueAndValidity();
					this.formUser.controls.nationality.clearValidators();
					this.formUser.controls.nationality.updateValueAndValidity();
					this.formUser.controls.nationality.disable();
					this.formUser.controls.state.clearValidators();
					this.formUser.controls.state.updateValueAndValidity();
					this.formUser.controls.state.disable();
					this.formUser.controls.city.clearValidators();
					this.formUser.controls.city.updateValueAndValidity();
					this.inputDisable = true;
				}
				this.inputDisableCpf = true;

				this.formCpf.controls.cpf.clearValidators();
				this.formCpf.controls.cpf.updateValueAndValidity();
			}

			this.showCompleteForm = true;
			this.sending = false;
			this.updateHeight();

		}, error => {

			if (time > 3) {
				this.preload(false);
			}	else {
				TweenMax.delayedCall(3 - time, () => {
					this.preload(false, 3 - time);
				});
			}
			clearInterval(timeLoader);


			if (!itsUpdating) {
				this.newUser = true;
				this.showCompleteForm = true;
				this.updateHeight();
				this.insertMode = true;
				this.updateMode = false;
				this.titleIndex = 2;
				this.sending = false;
			}

			if (showErrorMessage) {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			}
		});
	}

	sendToCompleteForm(itsUpdating, cpf) {
		this.preload(true);
		this.accountFound = false;

		this.formCpf.controls.cpf.enable();
		this.formUser.controls.name.enable();

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		if (time > 3) {
			this.preload(false);
		}	else {
			TweenMax.delayedCall(3 - time, () => {
				this.preload(false, 3 - time);
			});
		}
		clearInterval(timeLoader);

		if (!itsUpdating) {
			this.showCompleteForm = true;
			this.updateHeight();
			this.insertMode = true;
			this.updateMode = false;
			this.titleIndex = 2;
		}
	}

	changeNationality(value) {

		if (value === 'brazilian') {
			this.formUser.controls.state.setValidators(Validators.required);
			this.formUser.controls.state.updateValueAndValidity();
		} else {
			this.formUser.controls.state.clearValidators();
			this.formUser.controls.state.updateValueAndValidity();
		}

	}

	sendCpfForm () {
		this.updateMode = false;
		this.insertMode = false;
		this.submited = true;

		if (this.formCpf.valid && !this.sending) {
			this.sending = true;
			this.submited = false;

			this.getUserByCpf(false, this.formCpf.controls.cpf.value, false);
		}
	}

	addAuthToken() {
		Auth.passToken = this.formSignature.value.token ? this.formSignature.value.token : '';
		Auth.assinaturaEletronica = this.formSignature.value.eletronicSignature ? this.formSignature.value.eletronicSignature : '';
	}

	sendForm() {

		this.submited = true;

		if (!this.editUserData.userEditable && !this.newUser) {
			this.formUser.controls.gender.enable();
			this.formUser.controls.nationality.enable();
			this.formUser.controls.state.enable();
			this.editUserData.userRG = this.editUserData.userRG.trim();
			this.editUserDataSend.RG = this.editUserDataSend.RG.trim();
		}
		this.formUser.controls.rg.setValue(this.formUser.controls.rg.value.trim());

		if (this.formUser.valid && this.formSignature.valid && !this.sending) {

			this.preload(true);
			this.sending = true;
			this.submited = false;
			this.addAuthToken();

			this.autenticationService.sendDigitalSignature(this.formSignature.value.eletronicSignature).subscribe(d => {

				let time = 1;
				const timeLoader = setInterval(() => {
					time++;
				}, 1000);

				if (!this.editUserData.userEditable && !this.newUser) {
					this.userAdminService.sendUserDataEnd(this.editUserDataSend).subscribe((data: any) => {

						this.sending = false;

						if (time > 2) {
							this.preload(false);
						}	else {
							TweenMax.delayedCall(2 - time, () => {
								this.preload(false, 2 - time);
							});
						}

						this.updateUserTable();
						this.hide(data.Mensagem, 'success', true);

						clearInterval(timeLoader);

					}, error => {
						this.sending = false;

						if (time > 2) {
							this.preload(false);
						}	else {
							TweenMax.delayedCall(2 - time, () => {
								this.preload(false, 2 - time);
							});
						}
						clearInterval(timeLoader);

						if (error.error.Tipo !== 'tokenDatablinkValidado') {
							this.hide(error.error.Mensagem, 'error');
						} else {
							AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
						}

					});
				} else {
					this.userAdminService.sendUserData(this.formUser.value, this.formCpf.value, this.updateMode).subscribe((data: any) => {

						this.sending = false;

						if (time > 2) {
							this.preload(false);
						}	else {
							TweenMax.delayedCall(2 - time, () => {
								this.preload(false, 2 - time);
							});
						}

						this.updateUserTable();
						this.hide(data.Mensagem, 'success', true);

						clearInterval(timeLoader);

					}, error => {
						this.sending = false;

						if (time > 2) {
							this.preload(false);
						}	else {
							TweenMax.delayedCall(2 - time, () => {
								this.preload(false, 2 - time);
							});
						}
						clearInterval(timeLoader);

						if (error.error.Tipo !== 'tokenDatablinkValidado') {
							this.hide(error.error.Mensagem, 'error');
						} else {
							AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
						}

					});
				}


			}, error => {
				this.sending = false;
				this.preload(false);
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			});

		} else {

			setTimeout(() => {
				const scroll = $($(this.view).find('.error')[0]).offset().top;
				$(window).scrollTop(scroll - 100);
				this.updateHeight();
			}, 100);

		}

		if (!this.editUserData.userEditable && !this.newUser) {
			this.formUser.clearValidators();
			this.formUser.updateValueAndValidity();
			this.formUser.controls.gender.disable();
			this.formUser.controls.nationality.disable();
			this.formUser.controls.state.disable();
		}
	}

	updateUserTable() {
		AppEventDispatcher.dispatch(UserAdminEventType.USER_TABLE_UPDATE, null);
		this.formCpf.controls.cpf.enable();
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="user-admin"] .content', show: active, delay: delay});
	}

	show() {
		const timer = setInterval(() => {
			if ($(this.view).length > 0) {
				clearInterval(timer);

				const containerHeight = this.getStepHeight();
				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
			}
		}, 10);
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + 50;
	}

	updateHeight() {

		const timer = setInterval(() => {
			if ($('.form-user').length > 0) {
				clearInterval(timer);

				const containerHeight = this.getStepHeight();
				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});

			}
		}, 10);

	}

	hide(message, type, destroy = false) {
		AppEventDispatcher.dispatch(UserAdminEventType.USER_CONFIRM, { show: true, message: message, type: type });

		TweenMax.to(this.view, .8, { left: '-150%', ease: Quint.easeOut, onComplete: () => {
			if (destroy) {

				this.formCpf.reset();
				this.formUser.reset();
				this.formSignature.reset();
				this.insertMode = false;
				this.updateMode = false;
				this.accountFound = false;
				this.active = false;
				this.showCompleteForm = false;
			}
		}});
	}

	public getMessageConfirmedUser(message: boolean) {
		this.sendConfirmedUser = message;
	}

	public getLabelLastButton(): string {
		if (this.insertMode && !this.updateMode && !this.userNotEditable) {
			return 'Adicionar';
		} else if (!this.insertMode && this.updateMode && !this.userNotEditable) {
			return 'Atualizar';
		} else {
			return 'Finalizar';
		}
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/user-admin/new-user-data/new-user-data.component.ts